module.exports = __webpack_public_path__ + "node_modules/element-ui/lib/theme-chalk/fonts/element-icons.ttf?27c7209";


//////////////////
// WEBPACK FOOTER
// ./node_modules/element-ui/lib/theme-chalk/fonts/element-icons.ttf?t=1508751886602
// module id = 778
// module chunks = 0